import Vue from "vue";
import VueFormulate from "@braid/vue-formulate";

Vue.use(VueFormulate);
